import { Record, List } from 'immutable';

import { ActionTypes } from '../constants/AppConstants';
import BaseStore from './BaseStore';

const StationFinderState = new Record({
    latitude: null,
    longitude: null,
    error: null,
    stations: new List(),
    isExpanded: false,
});

export class StationFinderStore extends BaseStore {

    getInitialState () {
        return new StationFinderState();
    }

    getActionHandlers () {
        return {
            [ActionTypes.STATION_FINDER_SEARCH_STARTED]: this.handleSearchStarted,
            [ActionTypes.STATION_FINDER_SEARCH_COMPLETE]: this.handleSearchComplete,
            [ActionTypes.STATION_FINDER_SEARCH_FAILED]: this.handleSearchFailed,
            [ActionTypes.STATION_FINDER_STATIONS_CLEARED]: this.handleStationsCleared,
            [ActionTypes.STATION_FINDER_ERROR_CLEARED]: this.handleErrorCleared,
            [ActionTypes.STATION_FINDER_SET_EXPANDED]: this.handleExpand,
        };
    }

    getBounds () {
        const { stations } = this.state;
        const boundsArray = [];
        if (this.state.latitude && this.state.longitude) {
            boundsArray.push({lat: this.state.latitude, lng: this.state.longitude});
        }

        if (!stations || !stations.size) {
            return boundsArray;
        }

        stations.map((s) => boundsArray.push(s.getLatLng()));
        return boundsArray;
    }

    handleSearchStarted ({ latitude, longitude }) {
        this.setState(this.state.merge({
            error: null,
            latitude,
            longitude,
            stations: new List()
        }));
    }

    handleSearchComplete ({ stations }) {
        this.setState(this.state.set('stations', stations));
    }

    handleStationsCleared () {
        this.setState(this.state.set('stations', new List()));
    }

    handleErrorCleared () {
        this.setState(this.state.set('error', null));
    }

    handleExpand ({ value }) {
        this.setState(this.state.set('isExpanded', value));
    }

    handleSearchFailed ({ error }) {
        this.setState(this.state.set('error', error));
    }
}

export default new StationFinderStore();



// WEBPACK FOOTER //
// ./src/stores/StationFinderStore.js